import { BACKGROUND_MUSIC, GAME_MUSIC, GAME_SFX_BASE } from 'app/constants/GameSFX';
import { STATE_GAME, STATE_LEVELLOSE, STATE_LEVELEND } from 'app/constants/AppConstants';

export default class SoundController {
  constructor({ game, isMuted = false }) {
    this.game = game;
    this.sounds = {};
    this.sprites = {};
    this._allowMusic = !isMuted;
    this._allowEffects = !isMuted;
    this.backgroundMusic = { id: BACKGROUND_MUSIC, volume: SoundController.TITLEMUSIC_VOLUME };
    this.gameMusic = { id: GAME_MUSIC, volume: SoundController.GAMEMUSIC_VOLUME };

    Object.defineProperty(this, 'allowMusic', {
      get: function() {
        return this._allowMusic;
      },
      set: function(value) {
        this._allowMusic = value;
        if (this._allowMusic) {
          if (this.game.state.current === STATE_GAME || this.game.state.current === STATE_LEVELLOSE || this.game.state.current === STATE_LEVELEND) {
            this.playGameMusic();
          } else {
            this.playBackgroundMusic();
          }
        } else {
          this.pauseBackgroundMusic();
        }
      },
    });

    Object.defineProperty(this, 'allowEffects', {
      get: function() {
        return this._allowEffects;
      },
      set: function(value) {
        this._allowEffects = value;
        for (let i in this.sounds) {
          if (i != this.backgroundMusic.id) this.sounds[i].mute = this._allowEffects == false;
        }
      },
    });
  }

  /**
   * Touchlock and AudioContext handling
   */
  touchLock() {
    /**
     * Called from load state. Will handle touch locking here
     */
    if (this.game.sound.usingWebAudio && this.game.sound.context.state === 'suspended') {
      console.log('AudioContext is suspended');
      this.game.sound.setTouchLock(); // doesn't seem to do anything
      this.isTouchLocked = true;
    }
  }

  checkAudioContext() {
    /*
    if (this.isTouchLocked && this.game.sound.usingWebAudio) {
      console.log('AudioContext attempting resume');
      this.game.sound.context.resume().then(() => {
        console.log('AudioContext resumed successfully');
        this.isTouchLocked = this.game.sound.context.state === 'suspended';
      });
    }
    */
  }

  /**
   * End Touchlock and AudioContext handling
   */

  addSounds(sounds) {
    for (const sound of sounds) {
      this.addSound(sound, sound);
    }
  }
  addSound(id, assetKey) {
    this.sounds[id] = this.game.add.audio(assetKey);
    this.sounds[id].allowMultiple = true;
  }

  addAudioSprites(audioSprites) {
    for (const id of audioSprites) {
      this.addAudioSprite({ id });
    }
  }

  addAudioSprite({ id }) {
    this.sprites[id] = this.game.add.audioSprite(id);
    this.sprites[id].allowMultiple = true;
  }

  audioSpritesAreDecoded() {
    for (const sprite of this.sprites) {
      for (const s of sprite.sounds) {
        if (!s.isDecoded) {
          return false;
        }
      }
    }
    return true;
  }

  sfxExists(id, spriteID) {
    const exists = this.sprites[spriteID] && this.sprites[spriteID].sounds[id];
    if (!exists) {
      console.warn('Cant find ' + id + ' in audiosprite ' + spriteID + ', has it been added? (config.json and assetpack)');
    }
    return exists;
  }

  soundExists(id) {
    const exists = this.sounds[id];
    if (!exists) {
      console.warn('Cant find ' + id + ', has it been added? (config.json and assetpack)');
    }
    return exists;
  }

  playSFX(
    id,
    opts = {
      volume: 1,
      loop: false,
      delay: null,
      onComplete: null,
      onCompleteScope: null,
      spriteID: GAME_SFX_BASE,
    }
  ) {
    let { volume, loop = false, ignoreIfPlaying = false, delay = null, onComplete = null, onCompleteScope = null, spriteID = GAME_SFX_BASE } = opts;
    //this.checkAudioContext();
    if (this.game.device.ie || this.game.deviceController.isOldAppleDevice()) {
      this.playSound(id, opts);
      return true;
    }
    if (this.sprites[spriteID]) {
      if (spriteID === GAME_SFX_BASE) {
        if (!this.sprites[spriteID].sounds[id]) {
          // spriteID = GAME_SFX_EXTRA;
        }
      }
    }
    if (delay) {
      opts.delay = null;
      this.game.time.events.add(delay, this.playSFX, this, id, opts).autoDestroy = true;
      return true;
    }
    // if (this.isTouchLocked) {
    //     // console.log('playSFX : touch is locked ', id, opts);
    // }
    if (this._allowEffects) {
      //} && !this.isTouchLocked) {
      if (this.sfxExists(id, spriteID)) {
        if (ignoreIfPlaying && this.sprites[spriteID].get(id).isPlaying) {
          return false;
        }
        this.sprites[spriteID].get(id).loop = loop;
        this.sprites[spriteID].get(id).markers[id].loop = loop; // need to set loop in markers also
        this.sprites[spriteID].play(id, volume);
        if (onComplete) {
          const soundObj = this.sprites[spriteID].sounds[id];
          soundObj.onStop.addOnce(onComplete, onCompleteScope);
        }
      } else {
        return false;
      }
    } else if (onComplete) {
      /**
       * Fire the Signal immediately
       */
      const completeSignal = new Phaser.Signal();
      completeSignal.addOnce(onComplete, onCompleteScope);
      completeSignal.dispatch();
    } else {
      return false;
    }
    return true;
  }

  // used to stop looping audio : loop is defined in audiosprite json now!!
  stopSFX(id, opts = { spriteID: GAME_SFX_BASE }) {
    let { spriteID = GAME_SFX_BASE } = opts;
    if (this.sprites[spriteID]) {
      if (spriteID === GAME_SFX_BASE) {
        if (!this.sprites[spriteID].sounds[id]) {
          spriteID = GAME_SFX_EXTRA;
        }
      }
    }
    if (this.sfxExists(id, spriteID)) {
      this.sprites[spriteID].stop(id);
    }
  }
  stopAllSFX() {
    for (const i in this.sprites) {
      this.sprites[i].stop();
    }
  }
  /**
   * End audiosprites
   */

  /**
   * Background Music
   */

  stopBackgroundMusic() {
    const { id } = this.backgroundMusic;
    this.stopSound(id);
  }

  playBackgroundMusic() {
    //this.checkAudioContext();
    //if (!this.isTouchLocked) {
    const { id, volume } = this.backgroundMusic;
    const snd = this.sounds[id];
    this.stopGameMusic();
    if (snd && this.game.hud.isWelcomeScreen()) {
      if (this._allowMusic) {
        if (!snd.paused && !snd.isPlaying) {
          this.backgroundAudio = snd.play('', 0, 0, true);
          snd.volume = volume;
          // snd.fadeTo(1000, volume); <-- for some reason is failing on first load
        } else if (snd.paused) {
          snd.volume = 0;
          snd.resume();
          snd.fadeTo(500, volume);
        }
      }
    }
    //}
  }

  stopGameMusic() {
    const { id } = this.gameMusic;
    this.stopSound(id);
  }

  setGameMusicVolume(volume) {
    const { id } = this.gameMusic;
    this.setVolume(id, volume);
  }

  playGameMusic() {
    //this.checkAudioContext();
    //if (!this.isTouchLocked) {
    const { id, volume } = this.gameMusic;
    const snd = this.sounds[id];
    this.stopBackgroundMusic();
    if (snd) {
      if (this._allowMusic) {
        if (!snd.paused && !snd.isPlaying) {
          this.backgroundAudio = snd.play('', 0, 0, true);
          snd.volume = volume;
          // snd.fadeTo(1000, volume); <-- for some reason is failing on first load
        } else if (snd.paused) {
          snd.volume = 0;
          snd.resume();
          snd.fadeTo(500, volume);
        }
      }
    }
    //}
  }

  dimBackgroundMusic(value) {
    const { id, volume } = this.backgroundMusic;
    const snd = this.sounds[id];
    if (value) {
      snd.volume = volume / 4;
    } else {
      snd.volume = volume;
    }
  }

  pauseBackgroundMusic() {
    const { id } = this.backgroundMusic;
    if (this.game.hud.isWelcomeScreen()) {
      const snd = this.sounds[id];
      if (snd) {
        snd.pause();
      }
    }
  }

  playSound(
    id,
    opts = {
      volume: 1,
      loop: false,
      delay: null,
      onComplete: null,
      onCompleteScope: null,
    }
  ) {
    let { volume, loop = false, ignoreIfPlaying = false, delay = null, onComplete = null, onCompleteScope = null } = opts;
    if (this._allowEffects) {
      //} && !this.isTouchLocked) {
      if (this.soundExists(id)) {
        if (ignoreIfPlaying && this.sounds[id].isPlaying) {
          return false;
        }
        this.sounds[id].play();
      } else {
        return false;
      }
    } else {
      return false;
    }
    return true;
  }

  stopSound(id) {
    if (this.sounds[id]) {
      this.sounds[id].pausedPosition = 0;
      this.sounds[id].stop();
    }
  }

  isSoundPlaying(id) {
    if (this.sounds[id]) {
      return this.sounds[id].isPlaying;
    }
    return false;
  }

  stopAllSounds() {
    for (let i in this.sounds) {
      this.sounds[i].stop();
    }
  }

  setVolume(id, volume) {
    if (this.backgroundMusic.id == id) {
      this.backgroundMusic.volume = volume;
      this.sounds[id].fadeTo(1000, volume);
    } else {
      this.sounds[id].volume = volume;
    }
  }
}
SoundController.TITLEMUSIC_VOLUME = 0.2;
SoundController.GAMEMUSIC_VOLUME = 1;
